import Tickets from './Tickets';

export default Tickets;
